import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "6be8e15e-bf48-4581-904c-840f27f90dde",
    content: "Peak of the spectral envelope",
    options: {},
  },
  {
    id: "66953f6f-039d-423d-99b7-e7bdbf11cbce",
    content: "Tonality",
    options: {},
  },
  {
    id: "1b157b15-4222-4342-a158-283bbb8d25af",
    content: "Spectral fine structures",
    options: {},
  },
  {
    id: "e94ff51b-ac64-4808-87c8-e236c35cf955",
    content: "Spectral ‘centre of gravity’",
    options: {},
  },
  {
    id: "d7867a7e-a788-4539-8c4f-a0ac831e7d59",
    content: "Bandwidth",
    options: {},
  },
  {
    id: "e8569319-c46b-4cbb-9bc8-f70d9426d21e",
    content: "Centre frequencies of narrow bands",
    options: {},
  },
];

export const task: Task = {
  id: "058b3f63-ef4d-4c83-9937-b0fbc09e1ee5",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "6be8e15e-bf48-4581-904c-840f27f90dde",
    "e94ff51b-ac64-4808-87c8-e236c35cf955",
    "d7867a7e-a788-4539-8c4f-a0ac831e7d59",
    "e8569319-c46b-4cbb-9bc8-f70d9426d21e",
  ],
};
